@if (surveyEditorService.surveyEditor$().activeQuestion; as activeQuestion) {
  <form [formGroup]="activeQuestion">
    <div class="question-form__array with-actions">
      <div class="header row">
        <span class="label">Cards</span>
        <mat-slide-toggle
          [labelPosition]="'before'"
          [color]="'primary'"
          formControlName="randomizedCardsInd"
          [checked]="activeQuestion.value.randomizedCardsInd"
        >
          Randomized
        </mat-slide-toggle>
      </div>

      <div id="cards-array" formArrayName="cards" cdkDropList class="question-form_array_list" (cdkDropListDropped)="drop($event)">
        @for (cardCtrl of (activeQuestion.get('cards') | toFormArray).controls; track cardCtrl; let last = $last) {
          <div cdkDrag class="question-form_array_draggable">
            <div [formGroupName]="$index" class="question-form__array__input">
              <div *cdkDragPlaceholder class="drag-placeholder"></div>
              <fa-icon
                [class.eiq-hide]="(activeQuestion.get('cards') | toFormArray).controls.length === 1"
                [icon]="faGripDotsVertical"
                title="Re-order subquestion"
                cdkDragHandle
              ></fa-icon>
              <empathy-text-editor
                [id]="cardCtrl.value.id"
                [control]="cardCtrl.get('text')"
                [autofocus]="justAddedCardId === cardCtrl.value.id"
                [stopDefaultTab]="true"
                [splitOnPaste]="true"
                [hasMedia]="!!cardCtrl.value.stimulus?.mediaId"
                (tab)="onAddCard(last, $index)"
                (paste)="onPaste($event, $index)"
              >
                <div slot="prefix" class="eiq-id-badge">
                  <span>{{ cardCtrl.value.id }}</span>
                </div>
                <div slot="suffix" class="actions">
                  @if (cardCtrl.value.stimulus?.mediaId) {
                    <empathy-shared-stimulus
                      [stimulus]="[cardCtrl.value.stimulus]"
                      [height]="55"
                      [width]="82"
                      (delete)="onDeleteMedia($index)"
                    ></empathy-shared-stimulus>
                  } @else {
                    <button mat-icon-button [color]="'primary'" title="Add stimulus to this option" (click)="onAddStimulus($index)">
                      <fa-icon [icon]="faImage"></fa-icon>
                    </button>
                  }

                  <button
                    mat-icon-button
                    [color]="!cardCtrl.get('pinnedPositionInd').value ? 'primary' : 'alert'"
                    title="Pin Option Position"
                    [class.rotate-icon]="!cardCtrl.get('pinnedPositionInd').value"
                    [class.pinned]="cardCtrl.get('pinnedPositionInd').value"
                    (click)="cardCtrl.get('pinnedPositionInd').setValue(!cardCtrl.get('pinnedPositionInd').value)"
                  >
                    <fa-icon [icon]="faThumbTack"></fa-icon>
                  </button>

                  <button mat-icon-button color="primary" title="Card conditions" (click)="onOpenConditionals(cardCtrl)">
                    <fa-icon [icon]="faCodeBranch"></fa-icon>
                  </button>
                  @if ((activeQuestion.get('cards') | toFormArray).controls.length > 2) {
                    <button mat-icon-button color="warn" title="Delete card" (click)="onRemoveAt($index, cardCtrl.value.id)">
                      <fa-icon [icon]="faTrashCan"></fa-icon>
                    </button>
                  }
                </div>
              </empathy-text-editor>
              <fa-icon
                [class.eiq-hide]="cardCtrl.get('visibleWhen').value.length === 0"
                color="alert"
                [icon]="faCodeBranch"
                title="card has conditions"
              ></fa-icon>
            </div>
          </div>
        }
      </div>

      <div class="footer">
        <button mat-button color="primary" [disabled]="!addCardAllowed$()" (click)="onAddCard(true)">
          <fa-icon [icon]="faPlus"></fa-icon>
          New Card
        </button>
      </div>
    </div>
  </form>
}
